import { render, staticRenderFns } from "./BayItemEdit.vue?vue&type=template&id=27a8c40c&scoped=true&"
import script from "./BayItemEdit.vue?vue&type=script&lang=js&"
export * from "./BayItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./BayItemEdit.vue?vue&type=style&index=0&id=27a8c40c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8c40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a8c40c')) {
      api.createRecord('27a8c40c', component.options)
    } else {
      api.reload('27a8c40c', component.options)
    }
    module.hot.accept("./BayItemEdit.vue?vue&type=template&id=27a8c40c&scoped=true&", function () {
      api.rerender('27a8c40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayItem/coms/BayItemEdit.vue"
export default component.exports